/**
 * Created by bladron on 07/04/16.
 */
import Reflux from 'reflux';
import PostActions from "../actions/PostActions";
import moment from "moment";
import Constants from "../configurations/Constants";
import { filter as _filter, map as _map } from 'lodash';

const DEFAULT_DATE = moment().format("YYYY-MM-DDTHH:mm:ss.SSS") + "-0100";


class PostStore extends Reflux.Store {
    constructor() {
        super();

        this.listenTo(PostActions.getEventsBeforeDate.completed, this.onGetEvents);
        this.listenTo(PostActions.getMoreEvents, this.onGetMoreEvents);

        this.listenTo(PostActions.getPostBeforeDate.completed, this.onGetPost);
        this.listenTo(PostActions.getMorePost, this.onGetMorePost);

        this.listenTo(PostActions.getLatestGroups.completed, this.onGetGroups);
        this.listenTo(PostActions.getMoreGroups, this.onGetMoreGroups);

        this.listenTo(PostActions.getLatestLocalities.completed, this.onGetLocalities);
        this.listenTo(PostActions.getMoreLocalities, this.onGetMoreLocalities);



        this.posts = [];
        this.events = [];
        this.localities = [];
        this.groups = [];
        this.remainingPosts = 1;
        this.remainingEvents = 1;
        this.remainingGroups = 1;
        this.remainingLocalities = 1;

        this.onlyFollowed = false;

        this.userPosts = [];
    }

    /**
     * This method is used by server-side rendering
     *
     * Once MyWort React appliction is loaded, we initialize this store by calling this function with posts/events taken from a global variable in the DOM (see mywort/frontend/js/app.js)
     * @param posts {Array} array of initial posts
     * @param events {Array} array of initial events
     * @param localities {Array} array of initial events
     * @param groups {Array} array of initial groups
     */
    initialize(posts, events, localities, groups){
        this.posts = posts;
        this.events = events;
        this.localities = localities;
        this.groups = groups;

        if(!this.posts || this.posts.length < Constants.POST_BY_CALL ){
            this.remainingPosts = 0;
        }

        if(!this.events || this.events.length < Constants.POST_BY_CALL ){
            this.remainingEvents = 0;
        }

        if(!this.localities || this.localities.length < 10 ){
            this.remainingLocalities = 0;
        }

        if(!this.groups || this.groups.length < 10 ){
            this.remainingGroups = 0;
        }
    }

    onGetMorePost = () => {
        let beforeDate = this.posts.length > 0 ? this.posts[this.posts.length - 1].publishedAt : DEFAULT_DATE;
        PostActions.getPostBeforeDate(beforeDate);
    };

    onGetPost = (result) => {
        this.posts = this.posts.concat(result.teasers);
        this.remainingPosts = 1;
        if(result.teasers.length < Constants.POST_BY_CALL ){
            this.remainingPosts = 0;
        }
        this.trigger();
    };

    onGetMoreEvents = () => {
        let beforeDate = this.events.length > 0 ? this.events[this.events.length - 1].futureOccurrences[0] : DEFAULT_DATE;
        // Find all posts of this date to exclude in query
        let excludeIds = _map(_filter(this.events, (e) => {
            if(!e.futureOccurrences){
                return false;
            }
            return (e.nextOccurrence === beforeDate)
        }), 'id');
        PostActions.getEventsBeforeDate(moment(beforeDate ).format("YYYY-MM-DD"), excludeIds);
    };

    onGetEvents = (result) => {
        this.events = this.events.concat(result.teasers);
        this.remainingEvents = 1;
        if(result.teasers.length < Constants.POST_BY_CALL ){
            this.remainingEvents = 0;
        }
        this.trigger();
    };

    onGetMoreGroups = () => {
        let skip =  this.groups.length > 0 ? this.groups.length : 0;
        PostActions.getLatestGroups(skip);
    };

    onGetGroups = (result) => {
        this.groups = this.groups.concat(result.groups);
        this.remainingGroups = 1;
        if(result.groups.length < 10 ){
            this.remainingGroups = 0;
        }
        this.trigger();
    };

    onGetMoreLocalities = () => {
        let skip =  this.localities.length > 0 ? this.localities.length : 0;
        PostActions.getLatestLocalities(skip);
    };

    onGetLocalities = (result) => {
        this.localities = this.localities.concat(result.localities);
        this.remainingLocalities = 1;
        if(result.localities.length < 10 ){
            this.remainingLocalities = 0;
        }
        this.trigger();
    };
}

export default new PostStore();



// WEBPACK FOOTER //
// ./js/mywort/frontend/stores/PostStore.js